import React from 'react';
import {
  Grid,
  GridNoRecords,
  GridColumn as Column,
  GridDataStateChangeEvent
} from '@progress/kendo-react-grid';
import { useParams } from 'react-router-dom';
import { Loader } from '@progress/kendo-react-indicators';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { State, toDataSourceRequestString } from '@progress/kendo-data-query';

import {
  GridToolBar,
  GridToolbarDataStateChangeEvent
} from '../../../../components/grid/grid-tool-bar';
import { ColumnMenu } from '../../../../components/columnMenu';
import { NoRecords } from '../../../../components/grid/no-records';
import { DefaultGridSettings } from '../../../../constants/grid-settings';
import { useGetEventReportactions } from '../../../../hooks/services/use-reports';

const initialDataState: State = {
  sort: [{ field: 'competency', dir: 'asc' }],
  ...DefaultGridSettings.initialDataState
};

export const MeasurableReportTab: React.FC = () => {
  const { eventId, detailId } = useParams();

  const [dataState, setDataState] = React.useState<State>(initialDataState);

  const { data, isLoading } = useGetEventReportactions({
    eventId,
    type: 'measurables',
    playlistId: detailId,
    params: `${toDataSourceRequestString(dataState)}`
  });

  const gridExportRef = React.useRef<ExcelExport | null>(null);

  return (
    <div
      className={'pt-2'}
      style={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        width: '100%',
        overflow: 'hidden'
      }}>
      <GridToolBar
        searchPlaceholder={'Search measurable'}
        columnsToSearch={[
          'player',
          'team',
          'competency',
          'action',
          'measurable'
        ]}
        exportRef={gridExportRef}
        showGridMode={false}
        showCardMode={false}
        showBulkExport={true}
        {...dataState}
        onDataStateChange={(e: GridToolbarDataStateChangeEvent) => {
          setDataState(e.dataState);
        }}></GridToolBar>
      <ExcelExport
        data={data?.data ?? []}
        ref={gridExportRef}
        fileName={`measurables.xlsx`}>
        <Grid
          id={'grid-measurables'}
          style={{
            flexGrow: 1,
            minHeight: 0,
            height: '100%',
            overflow: 'hidden'
          }}
          pageable={DefaultGridSettings.pagerSettings}
          sortable={true}
          data={data}
          {...dataState}
          onDataStateChange={(e: GridDataStateChangeEvent) => {
            setDataState(e.dataState);
          }}>
          <Column
            field={'player'}
            title={'Player'}
            width={150}
            columnMenu={ColumnMenu}
          />
          <Column
            field={'team'}
            title={'Team'}
            width={150}
            columnMenu={ColumnMenu}
          />
          <Column
            field={'competency'}
            title={'Competency'}
            width={180}
            columnMenu={ColumnMenu}
          />
          <Column field={'action'} title={'Action'} columnMenu={ColumnMenu} />
          <Column
            field={'measurable'}
            title={'Measurable'}
            columnMenu={ColumnMenu}
          />

          <GridNoRecords>
            {isLoading ? (
              <div
                className={
                  'd-flex flex-column align-items-center gap-2 text-muted'
                }>
                <Loader type={'pulsing'} />
                <span>Loading data</span>
              </div>
            ) : (
              <NoRecords />
            )}
          </GridNoRecords>
        </Grid>
      </ExcelExport>
    </div>
  );
};
